import React from 'react'
import { Box, Chip } from '@mui/material'
import { useIsMobile } from '../../hooks/use-is-mobile'
import { MobilePillTabs } from '../../components/mobile/mobile-pill-tabs'

function CustomTabs({ tabs, currentTab, onClick }) {
    const isMobile = useIsMobile()

    if (isMobile) {
        return <MobilePillTabs tabs={tabs} value={currentTab} onChange={onClick} />
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: 3,
                overflow: 'auto',
            }}
        >
            {tabs.map((item, index) => {
                return (
                    <Chip
                        key={index}
                        onClick={() => {
                            onClick(item, index);
                        }}
                        size="medium"
                        label={item.label}
                        sx={{
                            ...(item.value !== currentTab && {
                                backgroundColor: 'transparent',
                                border: 'none',
                            })
                        }}
                    />
                );
            })}
        </Box>
    )
}

export default CustomTabs
